import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';

// @ts-expect-error untyped dependency
import { getBusinessUnitsKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
export const BASE_URL = 'business-units/v1/business-unit-displays/user/dropdown';
const _getBusinessUnits = () => http.get(`${BASE_URL}`);
const getBusinessUnits = () => getFromEarlyRequest(getBusinessUnitsKey(), () => _getBusinessUnits());
export default getBusinessUnits;